<template>
  <div class="container-principal">
    <h1 class="titulo-pagina">Tabela de Coparticipação</h1>

    <div class="card-formulario">
      <h2 class="subtitulo-formulario">Acesse sua tabela de coparticipação</h2>

      <form @submit.prevent="handleSubmit">
        <div class="campo-grupo">
          <label for="carteirinha" class="label-input"
            >Carteirinha Unimed</label
          >
          <input
            id="carteirinha"
            v-model="cardNumber"
            type="text"
            placeholder="Digite os números da sua carteirinha"
            class="input-texto"
            maxlength="21"
            required
            autocomplete="off"
          />
          <div class="container-mensagens">
            <p
              v-if="cardNumber.length > 0 && !isCardValid"
              class="erro-mensagem"
            >
              Carteirinha não encontrada. Confira o número no seu cartão (físico
              ou digital) e tente novamente.
            </p>
            <p class="legenda" v-if="isCardValid">
              Com esse dado, mostraremos só o que é relevante para o seu plano.
            </p>
          </div>
        </div>

        <div class="acoes">
          <button
            type="submit"
            class="botao-verde"
            :disabled="!isCardValid"
            :class="{ 'botao-desabilitado': !isCardValid }"
          >
            Exibir minha tabela
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "PesquisaTabelaCoparticipacao",
  props: {
    isShowButtonUFSC: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cardNumber: "",
    };
  },
  methods: {
    handleSubmit() {
      if (this.isCardValid) {
        this.pesquisarTabelaPlano(this.cardNumber);
      }
    },
    pesquisarTabelaPlano(parametro) {
      localStorage.setItem("Carteirinha", JSON.stringify(parametro));

      const plano = this.obterTipoTabela(parametro);
      localStorage.setItem("Plano", JSON.stringify(plano));

      let tipoPessoa = "pf";
      if (this.isShowButtonUFSC) tipoPessoa = "pj";

      localStorage.setItem("TipoPessoa", JSON.stringify(tipoPessoa));

      this.$router.push({ name: "Tabelas" });
    },
    obterTipoTabela(parametro) {
      if (parametro === "ATD-UNIFLEX") return "uniflex/personal";
      if (parametro === "ATD-LIGHT") return "light";
      if (parametro === "ATD-UFSC") return "ufsc";

      return "";
    },
  },
  computed: {
    isCardValid() {
      const validCodes = ["ATD-UNIFLEX", "ATD-LIGHT", "ATD-UFSC"];
      const cardUpper = this.cardNumber.toUpperCase();
      if (validCodes.includes(cardUpper)) {
        return true;
      }
      if (cardUpper.startsWith("A")) {
        return false;
      }
      return this.cardNumber.length === 21;
    },
  },
  watch: {
    cardNumber(value) {
      if (value.toUpperCase().startsWith("A")) {
        this.cardNumber = value.toUpperCase();
        return;
      }

      let v = value.replace(/\D/g, "");

      if (v.length > 4) v = v.replace(/^(\d{4})(\d)/, "$1.$2");
      if (v.length > 9) v = v.replace(/^(\d{4})\.(\d{4})(\d)/, "$1.$2.$3");
      if (v.length > 16)
        v = v.replace(/^(\d{4})\.(\d{4})\.(\d{6})(\d)/, "$1.$2.$3.$4");
      if (v.length > 19)
        v = v.replace(
          /^(\d{4})\.(\d{4})\.(\d{6})\.(\d{2})(\d)/,
          "$1.$2.$3.$4-$5",
        );

      this.cardNumber = v.substring(0, 21);
    },
  },
};
</script>

<style scoped>
.container-principal {
  background-color: #f3f3f3;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  padding: 20px;
}

.titulo-pagina {
  font-family: "UnimedSlab-SemiBold", sans-serif;
  color: var(--color-brand-primary);
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 30px;
}

.card-formulario {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  padding: 40px;
  width: 100%;
  max-width: 650px;
}

.subtitulo-formulario {
  font-family: "UnimedSlab-SemiBold", sans-serif;
  color: var(--color-brand-primary);
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 25px;
}

.campo-grupo {
  margin-bottom: 20px;
}

.container-mensagens {
  min-height: 50px;
}

.label-input {
  font-family: "UnimedSans-SemiBold", sans-serif;
  display: block;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
  font-size: 14px;
}

.input-texto {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 16px;
  color: #495057;
  box-sizing: border-box;
}

.input-texto:focus {
  outline: none;
  border-color: var(--color-brand-primary);
  box-shadow: 0 0 0 2px rgba(0, 153, 93, 0.1);
}

.legenda {
  color: var(--text-secondary);
  font-size: 12.8px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.2px; /* 150% */
  margin-top: 8px;
}

.acoes {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.botao-verde {
  font-family: "UnimedSans-SemiBold", sans-serif;
  background-color: var(--color-brand-primary);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.botao-verde:hover {
  background-color: #007f4e;
}

.botao-desabilitado {
  background-color: #ccc !important;
  cursor: not-allowed;
  opacity: 0.7;
}

.erro-mensagem {
  color: var(--color-status-error);
  font-size: 12.8px;
  margin-top: 8px;
  font-size: 12.8px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.2px;
}

.container-principal {
  background-image: url("../assets/images/bg-unimed-abstract.svg");
  background-repeat: no-repeat;
  background-size: 850px;
  background-position: center center;
  background-color: #ffffff;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}
</style>
